import request from '@/utils/request';

// 查询埋点会员数据
export const getTrackingMemberList = (values) => {
  return request('/activity-data/tracking-member/query', {
    method: 'POST',
    data: values,
  });
};

// 查询订阅消息模板会员数据
export const getTemplateMemberList = (values) => {
  return request('/activity-data/template-member/query', {
    method: 'POST',
    data: values,
  });
};

// 导出埋点会员明细
export const exportTrackingMember = (values) => {
  return request('/activity-data/tracking-member/export', {
    method: 'POST',
    data: values,
  });
};

// 导出订阅消息模板会员明细
export const exportTemplateMember = (values) => {
  return request('/activity-data/template-member/export', {
    method: 'POST',
    data: values,
  });
};
